import { Select } from "antd";
import { Game } from "model/ecosystem";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectGame, selectEnv } from "redux/actions/Game";
import gameService from "services/EcosystemService";
import { User } from "firebase/auth";

type Props = {
  selectedGame: Game;
  selectedEnv: string;
  user: User;
  selectGame: (g: Game) => void;
  selectEnv: (env: string) => void;
};

const GameSelector = (props: Props) => {
  const { selectedGame, selectGame, selectedEnv, selectEnv } = props;
  const [games, setGames] = useState<Game[]>([]);

  useEffect(() => {
    let isMounted = true;
    gameService.getGames().then((fetchedGames: Game[]) => {
      if (isMounted) {
        setGames(fetchedGames);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  const handleGameChange = (gameId: string) => {
    const gameToSelect = games.find((elm) => elm.id === gameId);
    if (gameToSelect) {
      selectGame(gameToSelect);
    }
  };

  const handleEnvChange = (env: string) => {
    selectEnv(env);
  };

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <Select value={selectedGame.id} onChange={handleGameChange}>
        {games.map((game) => (
          <Select.Option key={game.id} value={game.id}>
            {game.name}
          </Select.Option>
        ))}
      </Select>
      <Select
        value={selectedEnv}
        onChange={handleEnvChange}
        style={{ width: 200 }}
        disabled={selectedGame?.env?.length <= 1}
      >
        {selectedGame?.env?.map((env) => (
          <Select.Option key={env} value={env}>
            {env}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

const mapStateToProps = ({ game }: any) => {
  const { selectedGame, selectedEnv } = game;
  return { selectedGame, selectedEnv };
};

const mapDispatchToProps = {
  selectGame,
  selectEnv,
};

export default connect(mapStateToProps, mapDispatchToProps)(GameSelector);
